(ns common.schema.entities.ai-document-generation.core
  (:require
   [common.schema.entities.ai-document-generation.permissions :as permissions]
   [common.schema.entities.ai-document-generation.schema :as schema]))

(def entity-type-definition
  {:entity-type                          :entity.type/ai-document-generation
   :schema                               schema/schema
   :name                                 {:en "AI document generation"}
   :plural                               {:en "AI document generations"}
   :icon                                 :fa-file-word
   :display-name-fn                      (fn [{:keys [entity]}]
                                           (some-> entity
                                                   :ai-document-generation/task-type
                                                   name))
   :display-name/depends-on              [:ai-document-generation/task-type]
   :permissions                          {:creatable?   false
                                          :disableable? false}
   :entity/mcp-blacklisted?              true
   :read-permissions-check-fn            permissions/read-permissions?
   :disable-permissions-check-fn         permissions/disable-permissions?})
